import { onBeforeUnmount, onMounted } from 'vue';

type EventMapFor<T> = T extends Window
  ? WindowEventMap
  : T extends Document
    ? DocumentEventMap
    : T extends HTMLElement
      ? HTMLElementEventMap
      : Record<string, Event>;

// Register using addEventListener on mounted, and removeEventListener automatically on unmounted.
export function useEventListener<
  T extends EventTarget,
  K extends keyof EventMapFor<T>,
>(target: T, event: K, handler: (e: EventMapFor<T>[K]) => void) {
  onMounted(() => {
    target.addEventListener(event as string, handler as EventListener);
  });

  onBeforeUnmount(() => {
    target.removeEventListener(event as string, handler as EventListener);
  });
}
